module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatRoomRobby"
    }
  }, [_c('div', {
    attrs: {
      "id": "roomListHeader"
    }
  }, [_c('span', [_vm._v("개설된 채팅방 "), _c('strong', [_vm._v(_vm._s(Object.keys(_vm.items).length))]), _vm._v("개")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openRoomChatWindow('')
      }
    }
  }, [_vm._v("채팅방 바로가기")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chatRoomContainer"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('chatRoom', {
      key: index,
      attrs: {
        "roomInfo": item
      }
    })
  }), _vm._v(" "), _c('contextMenu')], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce86413"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-room-lobby.vue
// module id = 97
// module chunks = 0